export interface UseHapticReturn {
  triggerHaptic: () => void;
}

export const useHaptic = (): UseHapticReturn => {
  const triggerHaptic = () => {
    // Trigger device haptic feedback using the Vibration API
    if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
      try {
        navigator.vibrate(50);
      } catch {
        // Silently ignore if vibration is not supported
      }
    }
  };

  return {
    triggerHaptic,
  };
};

export default useHaptic;
